import { AfterburnEffect } from 'game/extended/heros/mage/afterburn/afterburn_effect'

export default {
    events: {},
    effects: {
        AfterburnEffect
    },
    requirements: {}
}